module.exports = __webpack_public_path__ + "img/icon-aqiyi.a638c8b9.png";